import {Component, OnInit} from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";
import {MessageService} from "../../core/services/message.service";
import {Router} from "@angular/router";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {LoginService} from "../../services/login.service";

@Component({
	selector: 'app-esqueci-minha-senha',
	templateUrl: './esqueci-minha-senha.component.html',
	styleUrls: ['./esqueci-minha-senha.component.scss']
})
export class EsqueciMinhaSenhaComponent implements OnInit {

	public form: FormGroup;

	constructor(private loadingService: NgxSpinnerService, private messageService: MessageService, private router: Router, private loginService: LoginService) {

	}

	ngOnInit() {
		this.form = new FormGroup({
			num_cpf: new FormControl(null, [
				Validators.required
			]),
			txt_email: new FormControl(null, [
				Validators.required
			])
		});
	}

	solicitar(): void {
		if(this.form.valid){
			this.loadingService.show();
			this.loginService.esqueciMinhaSenha(this.form.get("num_cpf").value, this.form.get("txt_email").value).subscribe(() => {
				this.loadingService.hide();
				this.messageService.showSuccess("Foi enviado um email com a nova senha");
				this.router.navigateByUrl("/login");
			}, (error) => {
				this.loadingService.hide();
				this.messageService.showResponseError(error);
			});
		}
	}

}
